// Domain 02 — LAN Switching
import u01 from './u01-vlans.js';
import u02 from './u02-access.js';
import u03 from './u03-trunks.js';
import u04 from './u04-native-allowed.js';
import u05 from './u05-trunk-ts.js';
import u06 from './u06-roas.js';
import u07 from './u07-intervlan-ts.js';
import u08 from './u08-stp.js';
import u09 from './u09-stp-config.js';
import u10 from './u10-stp-ts.js';
import u11 from './u11-etherchannel.js';
import u12 from './u12-ec-ts.js';
import u13 from './u13-l3switch.js';
import u14 from './u14-final.js';

export default {
  id: 'd02', number: '02', title: 'LAN Switching',
  tagline: 'VLANs, 802.1Q trunks, inter-VLAN routing, spanning tree, EtherChannel and Layer 3 switching.',
  units: [u01, u02, u03, u04, u05, u06, u07, u08, u09, u10, u11, u12, u13, u14],
};
